<template>
  <div class="sy-paas-text">
    <el-input
      v-on="$listeners"
      v-bind="{...$props}"
      :value="value"
      @blur="handleBlur"
      @input="handleInput"
    ></el-input>
  </div>
</template>

<script>
  import {shortTextProps} from '../index'

  export default {
    name: 'edit-short-text',
    props: shortTextProps,
    model: {
      prop: 'value',
      event: 'change'
    },
    methods: {
      handleInput (value) {
        this.$emit('change', value)
      },
      handleBlur (e) {
        this.$emit('change', e.target.value.replace(/^\s+|\s+$/g, ''))
      }
    }
  }
</script>

<style scoped lang="scss"></style>
